module.exports = __webpack_public_path__ + "img/empty-history.4ea8c77a.png";